const isProd = process.env.NODE_ENV === 'production'
  && !window.location.hostname.includes('stage')
  && !window.location.hostname.includes('smoke')

export default isProd
